import { Injectable } from '@angular/core';
import { environment } from 'src/environment/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiUrls, UserRole } from '../../constants/constants';
import { AuthToketRequest } from '../../interfaces/Requests/AuthTokenRequest';
import { AuthTokenResponse } from '../../interfaces/Responses/AuthTokenResponse';
import { StartCallResponse } from '../../interfaces/Responses/StartCallResponse';
import { CallInfoResponse } from '../../interfaces/Responses/CallInfoResponse';
import { chatMessageResponse } from 'src/app/models/chatMessageResponse';
import { ChatMessage } from 'src/app/models/chatMessage';
import { getImageBase64Response } from 'src/app/models/getImageBase64Response';
import { Assistance } from '../../interfaces/assistance';
import { AssetInfo } from '../../interfaces/AssetInfo';
import { AssistanceCreateResponse } from '../../models/assistanceCreateResponse';
import { contact } from 'src/app/models/contact';
import {catchError, Observable, throwError} from "rxjs";
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ApiService {
  constructor(private httpClient: HttpClient) { }

  loginToken(token: string) {
    var request = new AuthToketRequest()
    request.remoteEyeTokenLink = token;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<AuthTokenResponse>(environment.apiUrl + ApiUrls.loginToken, request, { headers });
  }

  getAssetInfo(assetId: number, userId: number, assistanceId: number | null) {
    console.log("getAssetInfo", assetId, userId);
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    var request = { "AssetId": assetId, "UserId": userId, "AssistanceId": assistanceId };
    return this.httpClient.post<AssetInfo>(environment.apiUrl + ApiUrls.assetInformation, request, { headers });
  }

  registerConnectionId(callId: number | null, connectionId: string | undefined, assetId: number, participantId: number) {
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    var request = { "CallId": callId, "ConnectionId": connectionId, "AssetId": assetId, "ParticipantId": participantId };
    return this.httpClient.post(environment.apiUrl + ApiUrls.setConnectionId, request, { headers });
  }

  hangUp(assetId: number, callId: number | null) {
    console.log("Sending Hang up for asset: " + assetId);
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    var request = { "AssetId": assetId, "CallId": callId };
    return this.httpClient.post<CallInfoResponse>(environment.apiUrl + ApiUrls.hangUp, request, { headers });
  }

  startCall(assetId: number, roleId: UserRole) {
    console.log("Sending start call for asset: " + assetId);
    var request = { "AssetId": assetId, "CallerRole": roleId };
    return this.httpClient.post<StartCallResponse>(environment.apiUrl + ApiUrls.startCall, request);
  }

  sendGeneralInfo(message: string, info: string) {
    console.log("Sending general information " + ApiUrls.generalInfo);
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    var request = { "JsonString": info, "Message": message };
    return this.httpClient.post<any>(environment.apiUrl + ApiUrls.generalInfo, request, { headers });
  }

  sendError(info: string) {
    console.log("Sending error " + ApiUrls.error);
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    var request = { "JsonString": info };
    return this.httpClient.post<any>(environment.apiUrl + ApiUrls.error, request, { headers });
  }

  updateTags(callId: number | null, tags: string[]) {
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    var request = { 'CallId': callId, 'Tags': tags.join(',') };
    return this.httpClient.post<any>(environment.apiUrl + ApiUrls.updateTags, request, { headers });
  }

  updateVideoTags(videoId: number | undefined, tags: string[]) {
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    var request = { 'VideoId': videoId, 'Tags': tags.join(',') };
    return this.httpClient.post<any>(environment.apiUrl + ApiUrls.updateVideoTags, request, { headers });
  }

  sendImage(callId: number, base64Img: string, userId: number, send: boolean, signalRConnectionId: string, assetId: number, IsLiveDraw: boolean, isHdImg: boolean) {
    console.log("Sending image " + ApiUrls.sendImage);
    var request = { "CallId": callId, "Base64Image": base64Img, "UserId": userId, "Send": send, "SignalrConnectionId": signalRConnectionId, "AssetId": assetId, "IsLiveDraw": IsLiveDraw, "IsHdImg": isHdImg };
    return this.httpClient.post<any>(environment.apiUrl + ApiUrls.sendImage, request);
  }

  startLiveDrawing(callId: number, base64Img: string, userId: number, signalRConnectionId: string, assetId: number) {
    console.log("Sending image " + ApiUrls.sendImage);
    var request = { "CallId": callId, "Base64Image": base64Img, "UserId": userId, "SignalrConnectionId": signalRConnectionId, "AssetId": assetId };
    return this.httpClient.post<any>(environment.apiUrl + ApiUrls.startLiveDrawing, request);
  }

  startVideoRecording(callId: number, base64Image: string, sessionId: string | null, userId: number, signalRConnectionId: string, assetId: number) {
    console.log("Sending start video recording " + ApiUrls.startVideoRecording);
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');

    var request = { "CallId": callId, "Base64Image": base64Image, "SessionId": sessionId, "UserId": userId, "SignalrConnectionId": signalRConnectionId, "AssetId": assetId };
    return this.httpClient.post<any>(environment.apiUrl + ApiUrls.startVideoRecording, request, { headers });
  }

  stopVideoRecording(videoId: number | undefined, userId: number, signalRConnectionId: string, assetId: number) {
    console.log("Sending stop video recording " + ApiUrls.stopVideoRecording);
    var request = { "VideoId": videoId, "UserId": userId, "SignalrConnectionId": signalRConnectionId, "AssetId": assetId };
    return this.httpClient.post<any>(environment.apiUrl + ApiUrls.stopVideoRecording, request);
  }

  requestHDImage(callId: number, userId: number, signalRConnectionId: string, assetId: number) {
    console.log("request hd image " + ApiUrls.requestHDImage);
    var request = { "CallId": callId, "UserId": userId, "SignalrConnectionId": signalRConnectionId, "AssetId": assetId };
    return this.httpClient.post<any>(environment.apiUrl + ApiUrls.requestHDImage, request);
  }

  sendHdImage(callId: number, base64Img: string, userId: number, send: boolean, signalRConnectionId: string, assetId: number, senderSRId: string) {
    console.log("Sending HD image " + ApiUrls.sendHdImage);
    var request = { "CallId": callId, "Base64Image": base64Img, "UserId": userId, "Send": send, "SignalrConnectionId": signalRConnectionId, "AssetId": assetId, senderSignalRId: senderSRId };
    return this.httpClient.post<any>(environment.apiUrl + ApiUrls.sendHdImage, request);
  }

  appendFile(formData: FormData, file: File | null, blob: Blob | null) {
    try {
      if (file != null) {
        console.log("API append file", file, file.size);
        formData.append('file', file);
      }

      if (blob != null) {
        console.log("API append blob", blob);
        formData.append('file', blob, 'capture.png');
      }
    }
    catch (e) { console.error(e); }

    return formData;
  }

  getFormDataUploadFile(signalRConnectionId: string, assetId: number, newMessage: ChatMessage, translate: boolean, translateLanguage: string, file: File | null, blob: Blob | null, assistanceId: number | null, username: String, includeFile: boolean) {
    const formData = new FormData();

    let fileMeta = null;
    if (file) {
      fileMeta = { fileName: file.name, contentType: file.type, fileSize: file.size };
    } else if (blob) {
      fileMeta = { fileName: 'capture.png', contentType: blob.type || 'image/png', fileSize: blob.size };
    }

    let messageRequest = { "AssetId": assetId, "ChatData": newMessage, "SignalRConnectionId": signalRConnectionId, "Translate": translate, "TranslateLanguage": translateLanguage, "AssistanceId": assistanceId, "UserName": username, "FileMeta": fileMeta };

    formData.append('request', JSON.stringify(messageRequest));

    if (includeFile) {
      this.appendFile(formData, file, blob);
    }

    return formData;
  }

  sendChatMessageCompleteFile(formData: FormData) {
      return this.httpClient.post<any>(environment.apiUrl + ApiUrls.sendChatMessage, formData, {
        reportProgress: true,
        observe: "events"
      });
  }

  async sendChatMessageFileChunksAsync(formData: FormData) {
     const response = await firstValueFrom(this.httpClient.post<{ messageId: string; uploadId: string }>(environment.apiUrl + ApiUrls.sendChatMessage, formData));
    return response;
  }

  async uploadFileInChunks(messageId: string, uploadId: string, file: File | Blob, onProgress?: (percent: number) => void) {
    const CHUNK_SIZE = 50 * 1024 * 1024; // 50MB
    const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
    const etags: { partNumber: number; eTag: string }[] = [];
    let uploadedBytes = 0;

    console.log("total chunks", totalChunks);

    for (let i = 0; i < totalChunks; i++) {
      const start = i * CHUNK_SIZE;
      const end = Math.min(start + CHUNK_SIZE, file.size);
      const chunk = file.slice(start, end);

      console.log("start - end", start, end);

      // Pedir URL prefirmada para el chunk
      const presignResp = await firstValueFrom(this.httpClient.post<{ url: string }>(environment.apiUrl + ApiUrls.getPresignedUrl, { messageId, uploadId, partNumber: i + 1 }));

      const presignedUrl = presignResp.url;

      // Subir chunk con reintentos y progreso
      const etag = await this.uploadChunkWithProgressAndRetry(presignedUrl, chunk, (chunkPercent) => {
        const totalPercent = ((uploadedBytes + (chunk.size * (chunkPercent / 100))) / file.size) * 100;
        if (onProgress) onProgress(Math.round(totalPercent));
      });

      etags.push({ partNumber: i + 1, eTag: etag });
      uploadedBytes += chunk.size;

      if (onProgress) onProgress(Math.round((uploadedBytes / file.size) * 100));
    }

    // Completar upload
    console.log("complete");
    await firstValueFrom(this.httpClient.post(environment.apiUrl + ApiUrls.completeUpload, { messageId, uploadId, parts: etags }));
    if (onProgress) onProgress(100);
  }

  // Función para subir un chunk con XMLHttpRequest y reportar progreso, más reintentos
  uploadChunkWithProgressAndRetry(url: string, chunk: Blob, onProgress?: (percent: number) => void, retries = 3): Promise<string> {
    return new Promise((resolve, reject) => {
      const attemptUpload = (attempt: number) => {
        const xhr = new XMLHttpRequest();
        xhr.open('PUT', url);

        xhr.upload.onprogress = (event) => {
          if (event.lengthComputable && onProgress) {
            const percent = (event.loaded / event.total) * 100;
            onProgress(percent);
          }
        };

        xhr.onload = () => {
          if (xhr.status >= 200 && xhr.status < 300) {
            const etag = xhr.getResponseHeader('ETag');
            if (!etag) reject(new Error('No ETag in response'));
            else resolve(etag);
          } else {
            if (attempt < retries) {
              setTimeout(() => attemptUpload(attempt + 1), 1000 * attempt); // backoff
            } else {
              reject(new Error(`Upload failed with status ${xhr.status}`));
            }
          }
        };

        xhr.onerror = () => {
          if (attempt < retries) {
            setTimeout(() => attemptUpload(attempt + 1), 1000 * attempt);
          } else {
            reject(new Error('Network error'));
          }
        };

        xhr.send(chunk);
      };

      attemptUpload(1);
    });
  }

  getChatForAsset(assetId: number, lastMessageId: number | null, userId: number | null, userRole: UserRole | null) {
    console.log("Get Chat Messages " + ApiUrls.getChatMessages);
    let request = { AssetId: assetId, LastMessageId: lastMessageId, UserId: userId, UserRole: userRole };
    return this.httpClient.post<chatMessageResponse>(environment.apiUrl + ApiUrls.getChatMessages, request);
  }

  getAudioFile(filePath: string) {
    console.log("Sending getAudioTranslated", ApiUrls.getAudioTranslated);
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    var request = { "FilePath": filePath };
    return this.httpClient.post<ArrayBuffer>(environment.apiUrl + ApiUrls.getAudioTranslated, request, { headers, responseType: 'arraybuffer' as 'json' });
  }

  callNotification(userId: number, assetId: number, signalRConnectionId: string, active: boolean, callTo: number) {
    var request = { "AssetId": assetId, "CallerId": userId, "SignalRId": signalRConnectionId, "CallTo": callTo, "Active": active };
    return this.httpClient.post<any>(environment.apiUrl + ApiUrls.callNotification, request);
  }

  callNotificationResponse(assetId: number, signalRConnectionId: string, callerId: number, accepted: boolean) {
    var request = { "AssetId": assetId, "SignalRId": signalRConnectionId, "CallerId": callerId, "Accepted": accepted };
    return this.httpClient.post<any>(environment.apiUrl + ApiUrls.callNotificationResponse, request);
  }

  registerEvent(eventTag: string, name: string, message: string, userId: number) {
    var request = { "EventTag": eventTag, "Name": name, "Message": message, "UserId": userId };
    this.httpClient.post<any>(environment.apiUrl + ApiUrls.activityLogsAdd, request).subscribe();
  }

  deleteMessage(messageId: number, assetId: number) {
    console.log("deleteMessage" + ApiUrls.deleteMessage);
    const request = { "Id": messageId, "AssetId": assetId };
    return this.httpClient.post<any>(environment.apiUrl + ApiUrls.deleteMessage, request);
  }

  getBase64Image(imageId: number, assetId: number) {
    console.log("getBase64 Image" + ApiUrls.getBase64Image);
    const request = { "ImageId": imageId, "AssetId": assetId };
    return this.httpClient.post<getImageBase64Response>(environment.apiUrl + ApiUrls.getBase64Image, request);
  }

  updateChatAssetUserName(assetId: number, userName: string, participantId: number) {
    const url = environment.apiUrl + ApiUrls.updateChatAssetUserName;
    let request = { "AssetId": assetId, "UserName": userName, "ParticipantId": participantId };
    return this.httpClient.post<any>(url, request);
  }

  createAssitance(assetId: number, userId: number, assistance: Assistance) {
    const url = environment.apiUrl + ApiUrls.createAssistance;
    let request = { "AssetId": assetId, "UserId": userId, "Assistance": assistance };
    return this.httpClient.post<AssistanceCreateResponse>(url, request);
  }

  changeAssitanceState(assetId: number, userId: number, assistanceId: number | null, state: number) {
    const url = environment.apiUrl + ApiUrls.changeAssistanceState;
    let request = { "AssetId": assetId, "UserId": userId, "AssistanceId": assistanceId, "State": state };

    return this.httpClient.post<any>(url, request);
  }

  changeAssitancePriority(assetId: number, userId: number, assistanceId: number | null, priority: number) {
    const url = environment.apiUrl + ApiUrls.changeAssistancePriority;
    let request = { "AssetId": assetId, "UserId": userId, "AssistanceId": assistanceId, "Priority": priority };

    return this.httpClient.post<any>(url, request);
  }

  getAssistanceReport(assistanceId: number) {
    var request = { "AssistanceId": assistanceId, "UserTimeZone": Intl.DateTimeFormat().resolvedOptions().timeZone };
    return this.httpClient.post<any>(environment.remoteeyeUrl + ApiUrls.assistanceReport, request, { responseType: 'text' as 'json' });
  }

  getAssistanceEmail(assistanceId: number) {
    var request = { "AssistanceId": assistanceId, "UserTimeZone": Intl.DateTimeFormat().resolvedOptions().timeZone };
    return this.httpClient.post<any>(environment.remoteeyeUrl + ApiUrls.emailAssistance, request);
  }

  getAssistancesStates() {
    return this.httpClient.get<{ name: string; id: number }[]>(environment.apiUrl + ApiUrls.assistancesStates);
  }

  getAssistancesPriorities() {
    return this.httpClient.get<{ [key: string]: number }>(environment.apiUrl + ApiUrls.assistancesPriorities);
  }

  getChatSummary(assetId: number, startDate: Date, endDate: Date, lang: string) {
    var request = { "AssetId": assetId, "StartDate": startDate, "endDate": endDate, "language": lang };
    return this.httpClient.post<any>(environment.apiUrl + ApiUrls.chatSummary, request);
  }

  reopenAssitance(assetId: number, userId: number) {
    const url = environment.apiUrl + ApiUrls.reopenAssistance;
    let request = { "AssetId": assetId, "UserId": userId };
    return this.httpClient.post<AssistanceCreateResponse>(url, request);
  }

  getAssistanceLink(assistanceId: number, userId: number) {
    const url = environment.apiUrl + ApiUrls.getAssistanceLink;
    let request = { "AssistanceId": assistanceId, "UserId": userId };
    return this.httpClient.post<any>(url, request);
  }

  generateAnonymousLink(assetId: number, assistanceId?: number | null): Observable<any> {
    const url = environment.remoteeyeUrl + ApiUrls.sendGenerateAnonimousLink;
    const request = { assetId: assetId, assistanceId: assistanceId };

    //const headers = new HttpHeaders({
    //  'Content-Type': 'application/json; charset=utf-8'
    //});

    return this.httpClient.post<any>(url, request).pipe(
      catchError((error) => {
        console.error('Error generating anonymous link:', error);
        return throwError(() => error);
      })
    );
  }

  addNewComment(assetId: number, userId: number, comment: string) {
    const url = environment.apiUrl + ApiUrls.addNewComment;
    let request = { "AssetId": assetId, "UserId": userId, "Comment": comment };
    return this.httpClient.post<any>(url, request);
  }

  deleteComment(assetId: number, userId: number, commentId: number) {
    const url = environment.apiUrl + ApiUrls.deleteComment;
    let request = { "AssetId": assetId, "UserId": userId, "CommentId": commentId };
    return this.httpClient.post<any>(url, request);
  }

  getContactsByClient(expertId: number) {
    const url = environment.remoteeyeUrl + ApiUrls.getContacts;
    let request = { "ExpertId": expertId };
    return this.httpClient.post<contact[]>(url, request);
  }

  sendInvitation(address: string, isEmail: boolean, name: string, assetId: number, contactId: number | null, userRole: UserRole | null, assistanceId: number | null) {
    const url = environment.remoteeyeUrl + ApiUrls.sendInvitation;
    let request = { "EmailPhoneNumber": address, "IsEmail": isEmail, "AssetId": assetId, "UserRole": userRole, "Name": name, "Id": contactId, "AssistanceId": assistanceId };
    return this.httpClient.post<any>(url, request);
  }

  checkIfContactExists(email: String | undefined, phonePrefix: String | undefined, phoneNumber: String | undefined) {
    const url = environment.remoteeyeUrl + ApiUrls.existContact;
    let request = {"Email": email, "PhonePrefix": phonePrefix, "PhoneNumber": phoneNumber };
    return this.httpClient.post<boolean>(url, request);
  }

  stopAudioConnector(sessionId: string, audioConnectorStreamId: string, userConnectionId: string) {
    const url = environment.apiUrl + ApiUrls.sendStopAudioConnector;
    let request = { "SessionId": sessionId, "AudioConnectorStreamId": audioConnectorStreamId, "UserConnectionId": userConnectionId };
    return this.httpClient.post<contact[]>(url, request);
  }

  addNewContact(name: string, company: string, email: string | null, phonePrefix: string, phoneNumber: string | null): Observable<boolean> {
    const url = environment.remoteeyeUrl + '/Contacts/Add';
    const request = {"Name": name, "Company": company, "Email": email, "PhonePrefix": phonePrefix, "PhoneNumber": phoneNumber };

    return this.httpClient.post<boolean>(url, request);
  }

  sendFirebaseToken(userId: number, userRole: UserRole, token: string) {
    const url = environment.apiUrl + ApiUrls.sendFirebaseToken;
    let request = { "UserId": userId, "UserRole": userRole, "Token": token };
    return this.httpClient.post<void>(url, request);
  }
}
